import React from 'react';
import Image from 'next/image';
import pureagilesvg from "../../public/svg/pureagile.svg";
import globalservices from "../../public/svg/globalservices.svg";
import workwithpartner from "../../public/svg/workwithpartner.svg";
import passionatesuccess from "../../public/svg/success.svg";
import solveproblems from "../../public/svg/solveproblems.svg";
import corevalues from "../../public/svg/supports.svg";
import overlay1 from "../../public/images/solutionoverlay1.png";
import overlay2 from "../../public/images/solutionoverlay2.png";
import overlay3 from "../../public/images/solutionoverlay3.png";
import overlay4 from "../../public/images/solutionoverlay4.png";
import overlay5 from "../../public/images/solutionoverlay5.png";
import overlay6 from "../../public/images/solutionoverlay6.png";

const flipBoxesData = [
  {
    icon: pureagilesvg,
    overlayimg: overlay1,
    title: "best interview tips",
    desc: "Streamlines timelines, enhances collaboration, and delivers the results you require, all while maintaining uncompromised quality."
  },
  {
    icon: globalservices,
    overlayimg: overlay2,
    title: ", resume writing tips",
    desc: "Our innovative approach dismantles barriers, making it simpler to connect and collaborate across international borders."
  },
  {
    icon: workwithpartner,
    overlayimg: overlay3,
    title: "online interview tips",
    desc: "Boost performance, enhance security and confidentiality, and ensure data safety, with complete control over the entire process."
  },
  {
    icon: passionatesuccess,
    overlayimg: overlay4,
    title: "virtual interview tips",
    desc: "Our platform connects emerging talents with opportunities, fostering a more optimistic outlook for the future."
  },
  {
    icon: solveproblems,
    overlayimg: overlay5,
    title: "interview preparation tips",
    desc: "Issues such as insufficient information, tight timelines, complex processes, geographical constraints, and mismatched opportunities can impact the entire campus hiring process."
  },
  {
    icon: corevalues,
    overlayimg: overlay6,
    title: "on campus placement",
    desc: "Our dedicated support team offers real-time assistance to ensure optimal speed, minimize latency, and maintain efficiency."
  }
];

const Itsolution = () => {
  return (
    <section className='mt-10'>
      <div className="elementor-background-overlay flex justify-center items-center">
        <div className=' 2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5'>
          <h2 className='text-[#fff] text-center lg:text-3xl text-xl'>Enabling Your Success,</h2>
          <h3 className='text-[#fff] text-center font-bold lg:text-4xl text-2xl'>We offer truly outstanding solutions.</h3>
          <div className="bar-main">
            <div className="bar bar-big"></div>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
            {flipBoxesData.map((box, index) => (
              <div className="flip-box" key={index}>
                <div className="flip-box-inner rs-flip-right">
                  <div className="flip-box-wrap">
                    <div className="front-part">
                      <div className="front-background-overlay"></div>
                      <div className="front-content-part">
                        <div className="front-icon-part">
                          <span className="front-icon"><i>
                            <Image src={box.icon} alt={box.title} /></i></span>
                        </div>
                        <div className="front-title-part">
                          <h5 className="front-title font-bold lg:text-lg">{box.title}</h5>
                        </div>
                        <div className="front-desc-part">
                          <p className="front-desc lg:text-base text-sm">{box.desc}</p>
                        </div>
                      </div>
                    </div>
                    <div className="back-part">
                      <div className="back-background-overlay">
                        <Image src={box.overlayimg} alt={box.title} className='w-full h-full'/>
                      </div>
                      <div className="back-content-part">
                        <div className="back-title-part">
                          <h4 className="back-title">{box.title}</h4>
                        </div>
                        <div className="back-desc-part">
                          <p className="back-desc">{box.desc}</p>
                        </div>
                        <div className="back-btn-part">
                          <span className="back-btn-txt back-btn button02">Read More</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
}

export default Itsolution;
